export const backendURL = 'https://admin.innoschool-learningsystem.eu';
export const apiURL     = backendURL + '/api';
export const storageURL = backendURL + '/storage';


